export enum CommonCookie {
  SilentLoginAttempted = 'silentLoginAttempted',
}
